







































import { Component, Prop, Vue } from "vue-property-decorator";
import Recommendation from "@/models/Recommendation";

@Component
export default class RecommendationsComponent extends Vue {
  private selectedRecommendationId = 1;
  public recommendations: Recommendation[] = [];

  get currentRecommendation(): Recommendation {
    return this.recommendations.filter(
      x => x.id === this.selectedRecommendationId
    )[0];
  }

  public getRecommendationState(id: number): string {
    return this.currentRecommendation.id !== id
      ? "recommendations__recommendation--hidden"
      : "";
  }

  public getAvatarState(id: number): string {
    return this.selectedRecommendationId !== id
      ? ""
      : "recommendations__avatar--active";
  }

  public setCurrentSelectedId(id: number) {
    this.selectedRecommendationId = id;
  }

  public created() {
    this.recommendations = [
      new Recommendation(
        1,
        "Stephen Donaghy",
        "recommendations.ste.position",
        "donaghy.webp",
        "recommendations.ste.recommendation"
      ),
      new Recommendation(
        2,
        "Joshua Duxbury",
        "recommendations.josh.position",
        "josh.webp",
        "recommendations.josh.recommendation"
      )
    ];
  }
}
